import useProductDynamicData from './useProductDynamicData'

export { useProductDynamicData }
